import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../core/signals.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../core/ReactiveMutableList.mjs';
import { listOfNotNull1v4ggfackvuny as listOfNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../core/Remember.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var WarningClass;
function Warning() {
  if (WarningClass === VOID) {
    class $ {
      constructor(summary, description) {
        description = description === VOID ? summary : description;
        this.iat_1 = summary;
        this.jat_1 = description;
      }
      kat() {
        return this.iat_1;
      }
      s91() {
        return this.jat_1;
      }
      toString() {
        return 'Warning(summary=' + this.iat_1 + ', description=' + this.jat_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.iat_1);
        result = imul(result, 31) + getStringHashCode(this.jat_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Warning()))
          return false;
        if (!(this.iat_1 === other.iat_1))
          return false;
        if (!(this.jat_1 === other.jat_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Warning');
    WarningClass = $;
  }
  return WarningClass;
}
var InvalidClass;
function Invalid() {
  if (InvalidClass === VOID) {
    class $ {
      constructor(summary, description) {
        description = description === VOID ? summary : description;
        this.lat_1 = summary;
        this.mat_1 = description;
      }
      kat() {
        return this.lat_1;
      }
      s91() {
        return this.mat_1;
      }
      toString() {
        return 'Invalid(summary=' + this.lat_1 + ', description=' + this.mat_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.lat_1);
        result = imul(result, 31) + getStringHashCode(this.mat_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Invalid()))
          return false;
        if (!(this.lat_1 === other.lat_1))
          return false;
        if (!(this.mat_1 === other.mat_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Invalid');
    InvalidClass = $;
  }
  return InvalidClass;
}
function IssueNode$disconnect$ref(p0) {
  var l = () => {
    p0.sat();
    return Unit_instance;
  };
  l.callableName = 'disconnect';
  return l;
}
var IssueNodeClass;
function IssueNode() {
  if (IssueNodeClass === VOID) {
    class $ {
      constructor(parent) {
        parent = parent === VOID ? null : parent;
        this.nat_1 = parent;
        this.oat_1 = Signal().hak(new (Constant())(_Constant___init__impl__v45mub(null)));
        this.pat_1 = ReactiveMutableList().vam();
        this.qat_1 = false;
        var tmp = this;
        tmp.rat_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = listOfNotNull($this$remember.daj($this$remember.daj(this.oat_1)));
          // Inline function 'kotlin.collections.flatMap' call
          var tmp0 = $this$remember.daj(this.pat_1);
          // Inline function 'kotlin.collections.flatMapTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            var list = $this$remember.daj(element.rat_1);
            addAll(destination, list);
          }
          return plus(tmp, destination);
        });
      }
      tat(issue) {
        this.oat_1.oam(new (Constant())(_Constant___init__impl__v45mub(issue)));
      }
      uat(issue) {
        this.oat_1.oam(remember(VOID, VOID, VOID, issue));
      }
      vat() {
        // Inline function 'kotlin.apply' call
        var this_0 = new (IssueNode())(this);
        this_0.wat();
        return this_0;
      }
      wat() {
        if (this.qat_1 || this.nat_1 == null)
          return Unit_instance;
        this.qat_1 = true;
        this.nat_1.pat_1.nam(this);
      }
      sat() {
        if (!this.qat_1 || this.nat_1 == null)
          return Unit_instance;
        this.qat_1 = false;
        this.nat_1.pat_1.mam(this);
      }
      kaj() {
        this.wat();
        return IssueNode$disconnect$ref(this);
      }
    }
    initMetadataForClass($, 'IssueNode', IssueNode);
    IssueNodeClass = $;
  }
  return IssueNodeClass;
}
//region block: exports
export {
  Invalid as Invalid2lchzzxcoxbzy,
  Warning as Warning3n5ye4cehejrw,
  IssueNode as IssueNode2x8c6ia7dmfdz,
};
//endregion

//# sourceMappingURL=IssueNode.mjs.map
